/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#NotificationsTable,#NotificationsTable a{color:#000}#NotificationsTable .notification-read,#NotificationsTable .notification-read a{color:#999}"];
export { styles as styles };
